import type { SecondaryMarketQuotesTabType } from '../../model';

export type SecondaryMarketQuoteWorkspaceActions =
  | SecondaryMarketQuotesWorkspaceAddTab
  | SecondaryMarketQuotesWorkspaceRemoveTab;

export function secondaryMarketQuoteWorkspaceAddTab(tabId: string, key: string, tabType: SecondaryMarketQuotesTabType) {
  return { type: 'SECONDARY_MARKET_QUOTES_WORKSPACE_ADD_TAB' as const, tabId, key, tabType };
}
export type SecondaryMarketQuotesWorkspaceAddTab = ReturnType<typeof secondaryMarketQuoteWorkspaceAddTab>;

export function secondaryMarketQuoteWorkspaceRemoveTab(
  tabId: string,
  tabType: SecondaryMarketQuotesTabType,
  productKey: string,
) {
  return {
    type: 'SECONDARY_MARKET_QUOTES_WORKSPACE_REMOVE_TAB' as const,
    tabId,
    tabType,
    productKey,
  };
}
export type SecondaryMarketQuotesWorkspaceRemoveTab = ReturnType<typeof secondaryMarketQuoteWorkspaceRemoveTab>;
